import { Vue, Component } from "vue-property-decorator";
import XTextarea from '@/components/x-textarea';
import CavCavite from '@/lib/models/cav-cavite';
import { State } from 'vuex-class';

@Component
export default class PartCommentaire extends Vue {

  @State(s => s.caviteEdit.editedCavite) data: CavCavite;

  render() {
    return (
      <div class="main-tab-inner">
        <div class="columns">
          <div class="column is-12">
            <div class="field">
              <label class="label is-small has-text-weight-normal">
                  <i>Cet espace vous permet d'apporter des informations complémentaires sur la cavité.</i>
              </label>
              <div class="control">
                <XTextarea vModel={this.data.commentaires} class="textarea is-small"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-cc137f5a/commentaire.tsx" });